import React, { Component } from "react";
import { connect } from "react-redux";
import {
  destroyKasms,
  getUserKasms,
  createKasms,
  getStatusKasms,
  execKasm,
  updateKeepalive,
  getUserImages,
  getUserDefaultImage,
} from "../../actions/actionDashboard";
import { logout } from "../../actions/actionLogin";
import { NotificationManager } from "react-notifications";
import LoadingSpinner from "../../components/LoadingSpinner/index";
import Proptypes from "prop-types";
import "react-select/dist/react-select.css";
import queryString from "query-string";

class Go extends Component {
  constructor(props) {
    super(props);
    this.state = {
      videoQuality: window.localStorage.getItem("video_quality") ? JSON.parse(window.localStorage.getItem("video_quality")) : 1,
      kasmId: "",
      currentId: null,
      url: "",
      loader: false,
      attempt: 0,
      pointPresenceValues: [],
      persistentProfileValues: [],
      showTips: true,
      toggleControlPanel: false,
      createClicked: false,
      createResumeClicked: false,
      disconnect: false,
      kasm_url: null,
      kasm_exec: null,
    };
    this.createKasm = this.createKasm.bind(this);
    this.handleResumeKasm = this.handleResumeKasm.bind(this);
    this.handleCreateSuccess = this.handleCreateSuccess.bind(this);
    this.setDefault = this.setDefault.bind(this);
    this.startKasm = this.startKasm.bind(this);
  }

  handleResumeKasm(kasm_id, kasm_exec, kasm_url) {
    this.setState({ kasmId: kasm_id, createResumeClicked: true });

    this.props
      .getStatusKasms(kasm_id)
      .then(() => {
        let kasm_exec_data = {
          kasm_id: kasm_id,
          kasm_exec: this.state.kasm_exec,
          kasm_url: this.state.kasm_url,
        };
        this.props
          .execKasm(kasm_exec_data)
          .then(() => {
            this.props.history.push("/kasm/" + kasm_id);
          })
          .catch(() => {
            console.trace("Navigating browser to /");
            this.props.history.push("/");
          });
      })
      .catch(() => {
        console.trace("Navigating browser to /");
        this.props.history.push("/");
      });
  }

  createKasm(imageId, available) {
    if (!available) {
      console.trace("Navigating browser to /");
      this.props.history.push("/");
      NotificationManager.error(
        "This image is not currently available. Agent may still be downloading Image.",
        "Image Loading",
        3000
      );
      return;
    }

    this.setState({ currentId: imageId, createClicked: true, kasm_exec: null });
    let currentImage = this.state.pointPresenceValues.find(
      (image) => image.imageId === imageId
    );
    let currentImage2 = this.state.persistentProfileValues.find(
      (image) => image.imageId === imageId
    );
    // For the /go url we will always use the persistent profile if its defined on the image.
    let persistent_profile_mode = "Enabled";
    window.localStorage.setItem(
      "persistent_profile_mode",
      persistent_profile_mode
    );
    this.props
      .createKasms({
        point_of_presence:
          currentImage && currentImage.value ? currentImage.value.value : "",
        persistent_profile_mode: persistent_profile_mode,
        image_id: imageId,
        x_res: window.innerWidth,
        y_res: window.innerHeight,
        kasm_url: this.state.kasm_url,
      })
      .then(() => {
        this.handleCreateSuccess();
      })
      .catch(() => this.handleCreateError());
  }

  handleCreateError() {
    const { createKasmsError, errorCreateMessageDetail } = this.props;
    this.setState({ createClicked: false });
    if (createKasmsError) {
      console.trace("Navigating browser to /");
      this.props.history.push("/");
      NotificationManager.error(createKasmsError, "Create Session", 3000);
      if (errorCreateMessageDetail) {
        console.error(errorCreateMessageDetail);
      }
    } else {
      console.trace("Navigating browser to /");
      this.props.history.push("/");
      NotificationManager.error("Gateway Time-out", "Create Session", 3000);
    }
  }

  handleCreateSuccess() {
    const { errorCreateMessage, errorCreateMessageDetail } = this.props;
    if (errorCreateMessage) {
      console.trace("Navigating browser to /");
      this.props.history.push("/");
      NotificationManager.error(errorCreateMessage, "Create Kasm", 3000);
      this.setState({ createClicked: false });
      if (errorCreateMessageDetail) {
        console.error(errorCreateMessageDetail);
      }
    } else {
      const { createdKasms } = this.props;
      if (createdKasms.kasm_id) {
        NotificationManager.success(
          "Session Created",
          "Successfully Created Session"
        );
        this.props.history.push("/kasm/" + createdKasms.kasm_id);
      }
    }
  }

  componentDidMount() {
    const values = queryString.parse(this.props.location.search);
    if (values.kasm_url) {
      this.setState({
        kasm_url: decodeURIComponent(values.kasm_url),
        kasm_exec: "go",
      });
    }
    this.props
      .getDefault()
      .then(() => {
        this.setDefault();
      })
      .catch(() => this.props.history.push("/userdashboard"));
  }

  setDefault() {
    const { userdefault } = this.props;
    let defaultID = null;

    if (userdefault && userdefault.user_image) {
      defaultID = userdefault.user_image;
    } else if (userdefault && userdefault.group_image) {
      defaultID = userdefault.group_image;
    }

    if (defaultID != null) {
      const call1 = this.props.getUserImages();
      const call2 = this.props.getUserKasms();
      Promise.all([call1, call2]).then(() => {
        this.startKasm(defaultID);
      });
    } else {
      this.props.history.push("/userprofile");
      NotificationManager.error(
        "Select Default in User Settings",
        "No Default Image",
        5000
      );
    }
  }

  startKasm(defaultID) {
    const { liveKasms, availableKasms } = this.props;
    let defaultKasm = availableKasms.find(
      (image) => image.image_id === defaultID
    );
    if (defaultKasm) {
      liveKasms
        .sort(function (a, b) {
          return a.kasm_id.localeCompare(b.kasm_id);
        })
        .map((kasm, index) => {
          if (kasm.image.image_id === defaultID) {
            this.setState({ kasm_id: kasm.kasm_id });
            this.handleResumeKasm(kasm.kasm_id);
          }
        });
      if (typeof this.state.kasm_id === "undefined") {
        this.setState({ kasm_id: defaultKasm.image_id });
        this.createKasm(defaultKasm.image_id, defaultKasm.available);
      }
    } else {
      this.props.history.push("/userprofile");
      NotificationManager.error(
        "Default Image not available",
        "Select Default Image",
        5000
      );
    }
  }

  render() {
    return "";
  }
}

Go.propTypes = {
  destroyKasms: Proptypes.func.isRequired,
  logout: Proptypes.func.isRequired,
  getUserKasms: Proptypes.func.isRequired,
  getUserImages: Proptypes.func.isRequired,
  createKasms: Proptypes.func.isRequired,
  updateKeepalive: Proptypes.func.isRequired,
  getStatusKasms: Proptypes.func.isRequired,
  execKasm: Proptypes.func.isRequired,
  destroyKasmsErrorMessage: Proptypes.object,
  liveKasms: Proptypes.array,
  availableKasms: Proptypes.array,
  deleteKasmsError: Proptypes.object,
  errorCreateMessage: Proptypes.string,
  errorCreateMessageDetail: Proptypes.string,
  createKasmsError: Proptypes.string,
  createdKasms: Proptypes.object,
  statusKasms: Proptypes.object,
  getstatuskasmsError: Proptypes.object,
  execKasmError: Proptypes.object,
  errorStatusKasmsMessage: Proptypes.object,
  type: Proptypes.string,
  execKasmLoading: Proptypes.bool,
  destroyKasmsLoading: Proptypes.func,
  className: Proptypes.object,
  createKasmsLoading: Proptypes.bool,
  getDefault: Proptypes.func.isRequired,
};

export default connect(
  (state) => ({
    errorCreateMessage: state.dashboard.errorCreateMessage || null,
    errorCreateMessageDetail: state.dashboard.errorCreateMessageDetail || null,
    deleteKasmsError: state.dashboard.deleteKasmsError || null,
    getstatuskasmsLoading: state.dashboard.getstatuskasmsLoading || null,
    execKasmLoading: state.dashboard.execKasmLoading || null,
    destroyKasmsErrorMessage: state.dashboard.destroyKasmsErrorMessage || null,
    createKasmsLoading: state.dashboard.createKasmsLoading || false,
    destroyKasmsLoading: state.dashboard.destroyKasmsLoading || null,
    createKasmsError: state.dashboard.createKasmsError || null,
    statusKasms: state.dashboard.statusKasms || null,
    execKasmError: state.dashboard.execKasmError || null,
    errorStatusKasmsMessage: state.dashboard.errorStatusKasmsMessage || null,
    fetchedKasms: state.dashboard.kasms || [],
    createdKasms: state.dashboard.createdKasms || null,
    availableKasms: state.dashboard.availableKasms,
    liveKasms: state.dashboard.liveKasms,
    userdefault: state.dashboard.userdefault,
  }),
  (dispatch) => ({
    logout: (logout_data) => dispatch(logout(logout_data)),
    destroyKasms: (data) => dispatch(destroyKasms(data)),
    getUserKasms: (payload_data) => dispatch(getUserKasms(payload_data)),
    createKasms: (data) => dispatch(createKasms(data)),
    updateKeepalive: (data) => dispatch(updateKeepalive(data)),
    getStatusKasms: (data) => dispatch(getStatusKasms(data)),
    execKasm: (data) => dispatch(execKasm(data)),
    getUserImages: (payload_data) => dispatch(getUserImages(payload_data)),
    getDefault: () => dispatch(getUserDefaultImage()),
  })
)(Go);



// WEBPACK FOOTER //
// ./src/views/Go/Go.js